"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContextProvider = exports.AppContext = void 0;
const react_1 = __importStar(require("react"));
const immutable_1 = require("immutable");
// eslint-disable-next-line @rushstack/typedef-var
exports.AppContext = react_1.createContext({
    isLoading: true,
    isVisible: () => false,
    theme: 'default',
    setTheme: () => { },
    setIsVisible: () => { },
    decreaseHttpRequestCount: () => { },
    increaseHttpRequestCount: () => { }
});
const AppContextProvider = ({ children }) => {
    const [theme, setTheme] = react_1.useState('default');
    const [httpRequestCount, setHttpRequestCount] = react_1.useState(0);
    const [visibleComponents, setVisibleComponents] = react_1.useState(immutable_1.Map());
    const isVisible = (componentName) => {
        return visibleComponents.get(componentName) || false;
    };
    const setIsVisible = (componentName, isVisible = true) => {
        setVisibleComponents((v) => v.set(componentName, isVisible));
    };
    const increaseHttpRequestCount = (count = 1) => {
        setHttpRequestCount((v) => v + count);
    };
    const decreaseHttpRequestCount = (count = 1) => {
        setHttpRequestCount((v) => v - count);
    };
    const isLoading = httpRequestCount > 0;
    return (react_1.default.createElement(exports.AppContext.Provider, { value: {
            isLoading,
            isVisible,
            theme,
            setTheme,
            setIsVisible,
            decreaseHttpRequestCount,
            increaseHttpRequestCount
        } }, children));
};
exports.AppContextProvider = AppContextProvider;
//# sourceMappingURL=AppContext.js.map